<template>
  <div class="flex goods-share-container">
    <div class="preview-wrapper">
      <div
        class="popup-wrapper"
        :style="{ backgroundImage: 'url(' + ruleForm.backgroundImg + ')' }"
      >
        <div
          class="avatar-wrapper"
          v-if="ruleForm.memberHeadPortraitState === 'yes'"
        >
          <img
            src="https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/93b50b2a24cf58baed5f37e354f40b0.png"
            alt
          />
        </div>
        <div class="title" v-if="ruleForm.memberNameState === 'yes'">
          小赖-D为你推荐好物
        </div>
        <div class="remark" v-if="ruleForm.recommendWordState === 'yes'">
          <span>{{
            ruleForm.recommendWordType === "custom"
              ? ruleForm.customizeWord
              : "商品卖点"
          }}</span>
        </div>
        <div
          class="goods-wrapper"
          :class="{ enlarge: ruleForm.spuMainPicSize === 'enlarge' }"
        >
          <img
            src="https://imgcdn.hemiao100.com/decoration/1c3b3c9ee4fa5c4c7cccc2aa5254055.png"
            alt
          />
        </div>
        <div
          class="activity-tag"
          v-if="ruleForm.spuPriceState === 'specialPrice'"
        >
          特价
        </div>
        <div class="footer flex">
          <div class="goods-info flex-1">
            <div class="goods-name" v-if="ruleForm.spuNameState === 'yes'">
              巴布豆(BOBDOG)柔薄乐动菠萝纸尿裤M30片
            </div>
            <div class="price-box">
              <span class="price" v-if="ruleForm.spuPriceState === 'vipPrice'"
                >￥88.00</span
              >
              <span
                class="price"
                v-if="ruleForm.spuPriceState === 'specialPrice'"
                >￥38.00</span
              >
              <span
                class="price"
                v-if="ruleForm.spuPriceState === 'wxshopPrice'"
                >￥999.00</span
              >
              <span
                v-if="ruleForm.spuPriceState === 'specialPrice'"
                class="origin-price"
                >￥38.00</span
              >
            </div>
          </div>
          <div>
            <div class="mp-code">
              <img
                src="https://imgcdn.hemiao100.com/hemiaoBase/mallDecoration/mpcode.png"
                alt
              />
            </div>
            <div
              v-if="ruleForm.columnNameState === 'yes'"
              class="column-name text-center"
            >
              {{ ruleForm.columnName }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-card class="card flex-1">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="140px"
        class="demo-ruleForm"
      >
        <el-form-item label="模板展示顺序：">
          <el-input
            size="small"
            type="number"
            placeholder="请输入模板展示顺序数字"
            v-model="ruleForm.seqNum"
          ></el-input>
          <div class="form-tip">设置页面展示顺序，数字越小越靠前</div>
        </el-form-item>
        <el-form-item label="模板启用状态：" prop="">
          <div class="switch-wrapper" style="width:380px">
            <el-switch
              v-model="ruleForm.enabledState"
              size="mini"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="yes"
              inactive-value="no"
            ></el-switch>
          </div>
        </el-form-item>
        <el-form-item label="默认背景图：" prop="">
          <div class="flex upload-upload-btn">
            <div
              class="btn flex flex-column flex-center open-file"
              @click="hmUploadVisible = true"
              v-if="!ruleForm.backgroundImg"
            >
              <div class="add-wrapper">
                <span class="hmicon icon-hao pointer"></span>
              </div>
              <span>上传活动背景图</span>
            </div>
            <div
              v-if="ruleForm.backgroundImg"
              class="priview mr10 flex item-end"
            >
              <img :src="ruleForm.backgroundImg" alt="主图" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="handleRemove">删除</el-button>
              </div>
            </div>
          </div>
          <span class="form-tip"
            >只能上传jpg/png文件，且不能超过1MB建议图片尺寸为650x940像素</span
          >
        </el-form-item>
        <el-form-item label="会员头像：" prop="">
          <el-radio-group
            v-model="ruleForm.memberHeadPortraitState"
            size="small"
          >
            <el-radio label="yes">显示</el-radio>
            <el-radio label="no">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="会员姓名：" prop="">
          <el-radio-group v-model="ruleForm.memberNameState" size="small">
            <el-radio label="yes">显示</el-radio>
            <el-radio label="no">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="推荐语：" prop="">
          <el-radio-group v-model="ruleForm.recommendWordState" size="small">
            <el-radio label="yes">显示</el-radio>
            <el-radio label="no">隐藏</el-radio>
          </el-radio-group>
          <div>
            <el-radio-group
              v-if="ruleForm.recommendWordState === 'yes'"
              v-model="ruleForm.recommendWordType"
              size="small"
              @change="ruleForm.customizeWord = ''"
            >
              <div class="flex">
                <el-radio label="custom">自定义推荐语内容</el-radio>
                <el-input
                  :disabled="ruleForm.recommendWordType !== 'custom'"
                  :rows="4"
                  maxlength="140"
                  type="textarea"
                  v-model.trim="ruleForm.customizeWord"
                  placeholder="请输入推荐语，限制140字以内"
                />
              </div>
              <div>
                <el-radio label="sellingPoint">使用商品卖点</el-radio>
              </div>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="商品名称：" prop="">
          <el-radio-group v-model="ruleForm.spuNameState" size="small">
            <el-radio label="yes">显示</el-radio>
            <el-radio label="no">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品图片尺寸：" prop="">
          <el-radio-group v-model="ruleForm.spuMainPicSize" size="small">
            <el-radio label="normal">常规</el-radio>
            <el-radio label="enlarge">放大</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="商品价格：" prop="">
          <el-radio-group v-model="ruleForm.spuPriceState" size="small">
            <el-radio label="vipPrice">会员价</el-radio>
            <el-radio label="specialPrice">活动价</el-radio>
            <el-radio label="wxshopPrice">网店售价</el-radio>
            <el-radio label="hidePrice">不显示</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="商品划线价：" prop="">
          <el-radio-group
            v-model="ruleForm.spuBasePriceState"
            size="small"
          >
            <el-radio label="yes">显示</el-radio>
            <el-radio label="no">隐藏</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="专栏名称：" prop="">
          <el-radio-group
            v-model="ruleForm.columnNameState"
            size="small"
            @change="ruleForm.columnName = ''"
          >
            <el-radio label="yes">显示</el-radio>
            <el-radio label="no">隐藏</el-radio>
          </el-radio-group>
          <div>
            <span class="mr20">专栏名称</span>
            <el-input
              :disabled="ruleForm.columnNameState !== 'yes'"
              size="small"
              placeholder="请输入专栏名称"
              v-model.trim="ruleForm.columnName"
              maxlength="12"
            ></el-input>
          </div>
        </el-form-item>
        <!-- <el-form-item label="商品图片：" prop="">
          <el-select size="small" v-model="ruleForm.spuImgType" placeholder="请选择商品展示图来源">
            <el-option label="商品主图" :value="0"> </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <div class="flex flex-center">
            <el-button type="primary" size="small" @click="save('ruleForm')"
              >保存</el-button
            >
            <el-button type="default" size="small" @click="backPrev"
              >返回</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-card>
    <hm-upload
      :hmUploadVisible="hmUploadVisible"
      fileDir="decoration"
      @cancleUpload="cancleUpload"
      @hmUploadSuccess="hmUploadSuccess"
    ></hm-upload>
  </div>
</template>

<script>
import HmUpload from "@/components/HmUpload";
import html2canvas from "html2canvas";

export default {
  components: {
    HmUpload
  },
  data() {
    return {
      hmUploadVisible: false,
      defaultBg:
        "https://imgcdn.hemiao100.com/36098302136909/decoration/2020-02-16/0b0345dd1a65642061baf96bef632c4.png",
      bg: "",
      rules: {},
      mode: "",
      shareId: "",
      ruleForm: {
        spuMainPicSize: "normal",
        seqNum: "",
        enabledState: "yes",
        backgroundImg: "",
        memberHeadPortraitState: "yes",
        memberNameState: "yes",
        recommendWordState: "yes",
        recommendWordType: "custom",
        customizeWord: "",
        spuNameState: "yes",
        spuPriceState: "vipPrice",
        spuBasePriceState: "yes",
        columnNameState: "yes",
        columnName: "",
        spuImgType: "",
        previewImg: ""
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    this.ruleForm.backgroundImg = this.defaultBg;
    this.mode = this.$route.query.mode;
    this.shareId = this.$route.query.shareId;
    const goodsTempRow = this.$store.state.decoration.goodsTempRow;
    for (let key in goodsTempRow) {
      if (this.ruleForm.hasOwnProperty(key)) {
        this.ruleForm[key] = goodsTempRow[key];
      }
    }
  },
  mounted() {},
  destroyed() {
    this.$store.commit("SET_GOODS_TEMP_ROW", {});
  },
  methods: {
    hmUploadSuccess(url) {
      this.ruleForm.backgroundImg = url;
      this.hmUploadVisible = false;
    },
    cancleUpload() {
      this.hmUploadVisible = false;
    },
    handleRemove() {
      this.ruleForm.backgroundImg = "";
    },
    async save(formName) {
      const canvas = await html2canvas(
        document.querySelector(".preview-wrapper"),
        {
          useCORS: true,
          backgroundColor: null
        }
      );
      const previewImg = canvas.toDataURL("image/png");
      const valid = await this.$refs[formName].validate();
      if (valid) {
        const params = JSON.parse(JSON.stringify(this.ruleForm));
        Object.assign(params, {
          previewImg
        });
        let commitName = "addGoodShareTemp";
        if (this.mode === "edit") {
          commitName = "editGoodShareTemp";
          Object.assign(params, {
            shareId: this.shareId
          });
        }
        const result = await this.$store.dispatch(commitName, params);
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.backPrev();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.goods-share-container {
  position: relative;
}
.preview-wrapper {
  position: fixed;
  top: 100px;
  width: 375px;
  height: 667px;
  background-image: url(https://imgcdn.hemiao100.com/36098302136909/decoration/2020-02-16/d33c78ce9e0c1f4bab3fff0c007bb07.png);
  background-size: 100% 100%;
  margin-right: 20px;
  .popup-wrapper {
    position: relative;
    margin: 90px auto 0;
    width: 295px;
    height: 470.5px;
    background-size: 100% 100%;

    .avatar-wrapper {
      background: #fff;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 22px;
      img {
        width: 100%;
      }
    }

    .goods-wrapper {
      position: absolute;
      top: 144px;
      width: 200px;
      height: 200px;
      left: 50%;
      transform: translateX(-50%);
      &.enlarge {
        top: 134px;
        width: 225px;
        height: 225px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }

    .title {
      position: absolute;
      top: 70px;
      left: 0;
      right: 0;
      text-align: center;
      font-weight: bold;
      font-size: 15px;
    }

    .remark {
      position: absolute;
      top: 96px;
      left: 32px;
      right: 32px;
      font-size: 12px;
      color: #666;
      word-break: break-all;
      text-indent: 2em;
    }

    .footer {
      position: absolute;
      left: 32px;
      right: 32px;
      top: 382px;
      .mp-code {
        img {
          margin-left: 8px;
          width: 48px;
        }
      }

      .column-name {
        font-size: 10px;
        margin: 5px;
      }

      .goods-name {
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 15px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .price-box {
        font-size: 16px;
        .price {
          color: #f72b2b;
        }
        .origin-price {
          text-decoration: line-through;
          color: #999999;
          margin-left: 10px;
          font-size: 12px;
        }
      }
    }
  }
}

.activity-tag {
  position: absolute;
  background: #f72b2b;
  color: #fff;
  top: 363px;
  left: 30px;
  transform: scale(0.8);
  font-size: 12px;
  padding: 2px 5px;
}

.switch-wrapper {
  text-align: right;
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 130px;
    height: 130px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}

.card {
  margin-left: 385px;
}
.priview {
  position: relative;
  width: 152px;
  min-height: 152px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
